
<template>
  <div class="master-test-manager">
    <h1>Manajemen Master Tes</h1>

    <!-- Form untuk Tambah atau Edit -->
    <div class="card">
      <h2>{{ isEditing ? 'Edit Tes' : 'Tambah Tes Baru' }}</h2>
      <!-- Ganti <form> yang lama dengan ini -->
<form @submit.prevent="handleSubmit" class="add-form">
  <div class="form-group">
    <label for="test-name">Nama Tes</label>
    <input id="test-name" v-model="currentTest.name" placeholder="e.g., Tes Kraepelin" required />
  </div>
  <div class="form-group full-width">
    <label for="test-desc">Deskripsi / Petunjuk Pengerjaan</label>
    <div v-if="descriptionEditor" class="editor-container">
      <div class="editor-toolbar">
        <!-- Tambahkan tombol-tombol toolbar di sini -->
        <button type="button" @click="descriptionEditor.chain().focus().toggleBold().run()">B</button>
        <button type="button" @click="descriptionEditor.chain().focus().toggleItalic().run()">I</button>
        <button type="button" @click="descriptionEditor.chain().focus().toggleOrderedList().run()">1.</button>
      </div>
      <EditorContent :editor="descriptionEditor" class="editor-content" />
    </div>
  </div>
  <div class="form-group short">
    <label for="test-duration">Durasi (menit)</label>
    <input id="test-duration" v-model.number="currentTest.duration_minutes" type="number" required />
  </div>
  <div class="form-group short">
    <label for="test-scoring-module">Modul Skoring</label>
    <select id="test-scoring-module" v-model="currentTest.scoring_module">
      <option value="default">Default (Dinamis UI)</option>
      <option value="ist">IST (Otomatis)</option>
      <option value="papi">PAPI Kostick</option>
      <option value="sds">SDS / Minat Karir</option>
      <option value="cfit">CFIT</option>
      <option value="disc">DISC</option>
    </select>
  </div>
  
  <div class="form-group full-width checkbox-group">
    <label class="checkbox-label">
      <input type="checkbox" v-model="currentTest.require_all_answers" />
      Wajibkan Peserta Menjawab Semua Soal (Tidak boleh ada soal kosong sebelum submit)
    </label>
  </div>
  
  <!-- Bagian Soal Hafalan -->
  <div class="form-group full-width separator">
    <label>Opsi Soal Hafalan (Opsional)</label>
  </div>
  <div class="form-group long">
    <label for="test-stimulus-text">Teks Stimulus</label>
    <textarea id="test-stimulus-text" v-model="currentTest.stimulus_text" rows="3"></textarea>
  </div>
  <!-- GANTI INPUT TEKS DENGAN INI -->
  <div class="form-group">
    <label for="stimulus-image-upload">Upload Gambar Stimulus (Opsional)</label>
    <input 
      id="stimulus-image-upload" 
      type="file" 
      @change="handleStimulusImageUpload" 
      accept="image/png, image/jpeg, image/gif"
      ref="stimulusFileUploader"
    />
    <!-- Tampilkan preview gambar dan URL yang dihasilkan -->
    <div v-if="currentTest.stimulus_image_url" class="image-preview">
      <img :src="`https://elevaretes.com${currentTest.stimulus_image_url}`" alt="Preview Gambar Stimulus">
      <button type="button" @click="clearStimulusImage" class="clear-btn">Hapus Gambar</button>
    </div>
    <small v-if="isUploadingStimulus">Mengupload gambar...</small>
  </div>
  <div class="form-group short">
    <label for="test-memo-duration">Durasi Hafalan (detik)</label>
    <input id="test-memo-duration" v-model.number="currentTest.memorization_duration_seconds" type="number" placeholder="e.g., 180" />
  </div>
  
  <div class="form-actions full-width">
    <button type="submit" class="primary">{{ isEditing ? 'Update Tes' : 'Simpan Tes Baru' }}</button>
    <button v-if="isEditing" type="button" @click="cancelEdit">Batal</button>
  </div>
</form>
    </div>

    <div class="card">
    <h2>Daftar Tes</h2>
      <div v-if="isLoading">Memuat daftar tes...</div>

      <table>
        <thead>
          <tr>
              <th>Nama Tes</th>
              <th>Deskripsi</th>
              <th>Durasi (Timer)</th>
              <th>Status</th> <!-- Kolom Baru -->
              <th>Soal</th>
              <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="test in tests" :key="test.id">
            <td>{{ test.name }}</td>
            <td>{{ test.description }}</td>
            <td>{{ test.duration_minutes }} menit</td>
            <td>{{ test.is_active ? 'Aktif' : 'Nonaktif' }}</td>
            <td>
                <router-link :to="{ name: 'QuestionManager', params: { id: test.id }, query: { name: test.name } }">
                  <button class="manage-btn">Kelola Soal</button>
                </router-link>
            </td>
            <td class="actions">
                <button @click="startEdit(test)" class="edit-btn">Edit</button>
                <!-- Ubah tombol Hapus -->
                <button @click="toggleActive(test.id)" :class="test.is_active ? 'delete-btn' : 'reactivate-btn'">
                {{ test.is_active ? 'Nonaktifkan' : 'Aktifkan' }}
                </button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- === TAMBAHKAN UI PAGINATION DI SINI === -->
    <div v-if="totalTests > 0" class="pagination-controls">
      <span>{{ pageInfo }}</span>
      <div class="buttons">
        <button @click="prevPage" :disabled="currentPage === 1">Sebelumnya</button>
        <button @click="nextPage" :disabled="currentPage === totalPages">Berikutnya</button>
      </div>
    </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, onBeforeUnmount } from 'vue'; // <-- Tambahkan 'computed' di sini
import apiClient from '@/services/api.js';
import { useEditor, EditorContent } from '@tiptap/vue-3';
import StarterKit from '@tiptap/starter-kit';

// --- State Baru untuk Pagination ---
const tests = ref([]);
const totalTests = ref(0);
const currentPage = ref(1);
const itemsPerPage = ref(5); // Tampilkan 5 item per halaman
// ---------------------------------
// --- State Baru untuk Upload Stimulus ---
const isUploadingStimulus = ref(false);
const stimulusFileUploader = ref(null); // ref untuk input file

const isLoading = ref(true);
const isEditing = ref(false);
// --- UBAH INISIALISASI AWAL ---
const currentTest = ref({
  id: null,
  name: '',
  description: '',
  duration_minutes: 30,
  is_active: true,
  require_all_answers: false,
  memorization_duration_seconds: null,
  stimulus_text: '',
  stimulus_image_url: '',
  scoring_module: 'default',
});

const descriptionEditor = useEditor({
  content: '',
  extensions: [ StarterKit ],
  onUpdate: ({ editor }) => {
    // Sinkronkan konten editor dengan state
    currentTest.value.description = editor.getHTML();
  },
});

// Hentikan editor saat komponen dihancurkan
onBeforeUnmount(() => {
  descriptionEditor.value.destroy();
});


// --- UBAH FUNGSI RESET ---
const resetForm = () => {
  isEditing.value = false;
  currentTest.value = {
    id: null,
    name: '',
    description: '',
    duration_minutes: 30,
    is_active: true,
    require_all_answers: false,
    memorization_duration_seconds: null,
    stimulus_text: '',
    stimulus_image_url: '',
    scoring_module: 'default',
  };
    if (stimulusFileUploader.value) {
    stimulusFileUploader.value.value = ''; // Reset input file
  }
};

// --- Computed Properties untuk Pagination ---
const totalPages = computed(() => {
  return Math.ceil(totalTests.value / itemsPerPage.value);
});

const pageInfo = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value + 1;
  const end = Math.min(start + itemsPerPage.value - 1, totalTests.value);
  return `Menampilkan ${start}-${end} dari ${totalTests.value} tes`;
});

const fetchTests = async () => {
  isLoading.value = true;
  try {
    const skip = (currentPage.value - 1) * itemsPerPage.value;
    const response = await apiClient.get(
      `/admin/tests/master-list?skip=${skip}&limit=${itemsPerPage.value}`
    );
    // Ambil data dari dalam objek respons
    tests.value = response.data.tests;
    totalTests.value = response.data.total_count;
  } catch (error) {
    console.error("Gagal memuat daftar tes:", error);
  } finally {
    isLoading.value = false;
  }
};
// --- Fungsi Baru untuk Navigasi Halaman ---
const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
    fetchTests();
  }
};

const prevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
    fetchTests();
  }
};

const handleSubmit = async () => {
  if (isEditing.value) {
    await updateTest();
  } else {
    await addTest();
  }
};

// src/views/admin/MasterTestManager.vue -> <script setup>

const addTest = async () => {
  try {
    // --- TAMBAHKAN DEBUGGING DI SINI ---
    console.log("PAYLOAD YANG DIKIRIM UNTUK CREATE:", currentTest.value);
    // ------------------------------------

    await apiClient.post('/admin/tests/', currentTest.value);
    resetForm();
    await fetchTests();
  } catch (error) {
    alert("Gagal menambahkan tes baru.");
    
    // --- TAMBAHKAN DEBUGGING ERROR DI SINI ---
    if (error.response && error.response.data) {
      console.error("Detail Error 422 dari Server:", error.response.data.detail);
    }
    console.error(error);
    // ----------------------------------------
  }
};

// --- FUNGSI BARU UNTUK UPLOAD GAMBAR STIMULUS ---
const handleStimulusImageUpload = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  isUploadingStimulus.value = true;
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await apiClient.post('/admin/upload-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    // Set URL gambar di form setelah berhasil di-upload
    currentTest.value.stimulus_image_url = response.data.file_url;
  } catch (err) {
    alert("Gagal mengupload gambar stimulus.");
    console.error(err);
  } finally {
    isUploadingStimulus.value = false;
  }
};

// Fungsi untuk menghapus gambar yang sudah di-upload dari form
const clearStimulusImage = () => {
  currentTest.value.stimulus_image_url = '';
  if (stimulusFileUploader.value) {
    stimulusFileUploader.value.value = ''; // Reset input file
  }
};

const updateTest = async () => {
  try {
    const { id, ...updateData } = currentTest.value;
    
    // --- TAMBAHKAN DEBUGGING DI SINI ---
    console.log("Data yang dikirim untuk UPDATE:", updateData);
    // ------------------------------------

    await apiClient.put(`/admin/tests/${id}`, updateData);
    resetForm();
    await fetchTests();
  } catch (error) {
    // --- TAMBAHKAN DEBUGGING DI SINI ---
    console.error("Error 422, respons dari server:", error.response.data);
    // ------------------------------------
    alert("Gagal mengupdate tes.");
  }
};

const startEdit = (test) => {
  isEditing.value = true;
  currentTest.value = { ...test };
};

const cancelEdit = () => {
  resetForm();
};

const toggleActive = async (testId) => {
  const test = tests.value.find(t => t.id === testId);
  const action = test.is_active ? 'menonaktifkan' : 'mengaktifkan';
  if (window.confirm(`Yakin ingin ${action} tes ini?`)) {
    try {
      await apiClient.put(`/admin/tests/${testId}/toggle-active`);
      await fetchTests(); // Muat ulang data untuk melihat status baru
    } catch (error) {
      alert(`Gagal ${action} tes.`);
      console.error(error);
    }
  }
};


onMounted(fetchTests);
</script>


<style scoped>
.master-test-manager {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #333;
}

h1 {
  margin: 0 0 20px 0;
  font-size: 1.8em;
  color: #2c3e50;
  font-weight: 600;
}

h2 {
  margin: 0 0 20px 0;
  color: #2c3e50;
  font-size: 1.4em;
  font-weight: 600;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 10px;
}

.card {
  margin-top: 28px;
  padding: 28px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
  border: 1px solid #eee;
}

/* --- Form Tambah/Edit Tes --- */
.add-form {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 30px;
  align-items: flex-start;
}

.form-group {
  display: flex;
  flex-direction: column;
  flex: 2;
  min-width: 200px;
}

.form-group.short {
  flex: 1;
  min-width: 140px;
}

.form-group.full-width {
  flex-basis: 100%;
  min-width: 0;
}

.form-group label {
  margin-bottom: 6px;
  font-size: 0.95em;
  color: #555;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.form-group input,
.form-group textarea,
.form-group select {
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1em;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  outline: none;
  border-color: #1abc9c;
  box-shadow: 0 0 0 2px rgba(26, 188, 156, 0.2);
}

.form-group textarea {
  min-height: 100px;
  resize: vertical;
}

.form-group.separator {
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eee;
}

.checkbox-group {
  margin-top: 10px;
  margin-bottom: 10px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 500;
  color: #2c3e50;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.form-group.separator label {
  font-size: 1.1em;
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 8px;
}

.form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
  flex-wrap: wrap;
}

.form-actions button {
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  font-size: 0.95em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.form-actions button.primary {
  background-color: #1abc9c;
  color: white;
}
.form-actions button.primary:hover {
  background-color: #16a085;
}

.form-actions button.secondary {
  background-color: #6c757d;
  color: white;
}
.form-actions button.secondary:hover {
  background-color: #5a6268;
}

.manage-btn {
  background-color: #17a2b8;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 0.9em;
  cursor: pointer;
  transition: background-color 0.2s;
}
.manage-btn:hover {
  background-color: #138496;
}

/* --- Tabel Daftar Tes --- */
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,0.05);
}

th, td {
  text-align: left;
  padding: 14px 16px;
  border-bottom: 1px solid #eee;
  font-size: 0.95em;
}

th {
  background-color: #f8f9fa;
  color: #555;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 0.85em;
}

tr:hover {
  background-color: #f9fafb;
}

.inactive-row {
  background-color: #f8f9fa !important;
  color: #adb5bd !important;
}

.inactive-row th,
.inactive-row td {
  color: #adb5bd !important;
  font-style: italic;
}

.actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.actions button {
  padding: 6px 12px;
  border-radius: 6px;
  border: none;
  font-size: 0.85em;
  cursor: pointer;
  transition: background-color 0.2s;
}

.edit-btn {
  background-color: #ffc107;
  color: #212529;
}
.edit-btn:hover {
  background-color: #e0a800;
}

.delete-btn {
  background-color: #e74c3c;
  color: white;
}
.delete-btn:hover {
  background-color: #c0392b;
}

.reactivate-btn {
  background-color: #28a745;
  color: white;
}
.reactivate-btn:hover {
  background-color: #218838;
}

/* --- Pagination --- */
.pagination-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
  flex-wrap: wrap;
  gap: 16px;
}

.pagination-controls span {
  font-size: 0.9em;
  color: #555;
}

.pagination-controls .buttons {
  display: flex;
  gap: 8px;
}

.pagination-controls button {
  padding: 8px 14px;
  border: 1px solid #ddd;
  background-color: #fff;
  border-radius: 6px;
  font-size: 0.9em;
  cursor: pointer;
  transition: all 0.2s;
}

.pagination-controls button:hover:not(:disabled) {
  border-color: #1abc9c;
  color: #1abc9c;
}

.pagination-controls button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
  border-color: #eee;
  color: #ccc;
}

.pagination-controls button.active {
  background-color: #1abc9c;
  color: white;
  border-color: #1abc9c;
}

/* --- Responsif --- */
@media (max-width: 768px) {
  .master-test-manager {
    padding: 20px;
  }

  h1 {
    font-size: 1.6em;
  }

  .add-form {
    flex-direction: column;
    gap: 16px;
  }

  .form-group,
  .form-actions {
    width: 100%;
    min-width: auto;
  }

  .form-actions {
    justify-content: flex-end;
    margin-top: 16px;
  }

  table {
    font-size: 0.9em;
  }

  th, td {
    padding: 12px 12px;
  }

  .actions button {
    padding: 6px 10px;
  }

  .pagination-controls {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .pagination-controls .buttons {
    justify-content: center;
  }
}
.image-preview {
  margin-top: 10px;
  border: 1px dashed #ccc;
  padding: 10px;
  border-radius: 4px;
  display: inline-block; /* Agar tidak mengambil lebar penuh */
  position: relative;
}
.image-preview img {
  max-width: 200px;
  max-height: 200px;
  display: block;
}
.clear-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: #e74c3c;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
  font-weight: bold;
}
.editor-container {
  border: 1px solid #ccc;
  border-radius: 6px;
}
.editor-toolbar {
  background-color: #f8f9fa;
  padding: 5px;
  border-bottom: 1px solid #ccc;
}
.editor-toolbar button {
  /* ... style untuk tombol toolbar ... */
}
.editor-content {
  padding: 10px;
  min-height: 150px;
}
/* Anda perlu menambahkan style untuk output Tiptap di dalam .editor-content */
.editor-content :deep(.ProseMirror:focus) {
  outline: none;
}
.editor-content :deep(p) {
  margin: 0;
}
.editor-content :deep(ol) {
  padding-left: 20px;
}

</style>